import React, { useRef, useEffect, useState, Fragment } from 'react';

import TopicList from './topic-list';
import AlphabeticalList from './alphabetical-list';

const CategoriesLists = (props) => {
  let ticking = false;
  let lists = [];
  const topics = useRef();
  const [currentActiveLetter, setCurrentActiveLetterState] = useState('');
  const [alphabeticalListActive, setAlphabeticalListActive] = useState(
    !props.modalIsOpen
  );

  const addTopicListToHandles = (topicList) => {
    lists.push(topicList);
  };

  const throttleScroll = (container) => {
    ticking =
      ticking ||
      requestAnimationFrame(() => {
        ticking = false;

        //Magic!
        lists.forEach((topic) => {
          topic.isTopicInRange(container);
        });
      });
  };

  const setCurrentActiveLetter = (letter) => {
    setCurrentActiveLetterState(letter);
  };

  const returnToAlphabeticListHandler = () => {
    setAlphabeticalListActive(!alphabeticalListActive);
  };

  useEffect(() => {
    const elm = topics.current;
    elm.addEventListener('scroll', () => throttleScroll(elm), false);
  }, []);

  useEffect(() => {
    setAlphabeticalListActive(props.modalIsOpen);
  }, []);

  const topicLists = props.Content.AOCareTypes.map((letter, index) => {
    return (
      <TopicList
        key={`${letter.Key}-${index}`}
        isInRange={letter.Key === currentActiveLetter}
        addTopicListToHandles={(topicList) => addTopicListToHandles(topicList)}
        setCurrentActiveLetter={(letter) => setCurrentActiveLetter(letter)}
        letter={letter.Key}
        categories={letter.Categories}
        returnToAlphabetic={() => returnToAlphabeticListHandler()}
        selectedCareType={props.selectedCareType}
        careTypeChangeHandler={props.careTypeChangeHandler}
      />
    );
  });

  return (
    <Fragment>
      <header className="categories-lists__header">
        <h2 className="categories-lists__heading" tabIndex="0">
          {props.Content.Translations.all}
        </h2>
        <span className="show-for-sr">
          {props.Content.Translations.aodescription}
        </span>
      </header>
      <div className="categories-lists__list-wrapper">
        <AlphabeticalList
          currentActiveLetter={currentActiveLetter}
          list={props.Content.AOCareTypes}
          modalIsOpen={props.modalIsOpen}
          alphabeticalListActive={alphabeticalListActive}
          returnToAlphabeticListHandler={() => returnToAlphabeticListHandler()}
          aodescription={props.Content.Translations.aodescription}
        />
        <div ref={topics} className="categories-lists__topics">
          {topicLists}
        </div>
      </div>
    </Fragment>
  );
};

export default CategoriesLists;
